import axios from 'axios';
import qs from 'qs';
import md5 from 'blueimp-md5'
//import moment from 'moment';
//import env from '../../build/env';
//import semver from 'semver';
//import packjson from '../../package.json';

let util = {

};
util.getlocation = function () {
    var _location = window.location.search;
    _location = qs.parse(_location, { ignoreQueryPrefix: true });
    return _location;
};

util.title = function (title) {
    title = title || 'iView admin';
    window.document.title = title;
};

const ajaxUrl = 'http://127.0.0.1:8888';
util.ajax = axios.create({
    baseURL: ajaxUrl,
    timeout: 30000
});

util.mixmd5 = (data)=>{
    return md5("@yuanex" + data);
}

util.getbeijingTime = (date, i)=>{
    //console.log('beijingTime',/:/.test(date) || /-/.test(date),i)
    // if (/:/.test(date) || /-/.test(date)) {
    //     return date;
    // } else {
        
    // }
    var d;
    i == undefined ? i = 8 : "";
    //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
    if (typeof i !== 'number') return;
    if(date){
        d = new Date(date);
    }else{
        d = new Date();
    }
    //得到1970年一月一日到现在的秒数
    var len = d.getTime();
    //本地时间与GMT时间的时间偏移差
    var offset = d.getTimezoneOffset() * 60000;
    //得到现在的格林尼治时间
    var utcTime = len + offset;
    //console.log(utcTime + 3600000 * i)
    return new Date(utcTime + 3600000 * i);
}

util.formatDate = (date, type, i)=>{
    //console.log(moment(date))
    (typeof date =='string')&&(date.indexOf('-')>0)?date = date.replace(/-/g,"/"):''
    if (new Date(date) == 'Invalid Date') {
        return date;
    } else if (date != undefined) {  
        if(i!=undefined&&i!==''){
            date = util.getbeijingTime(date,i);
        }else{
            date = new Date(date);
        }
        const y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let M = date.getMinutes();
        M = M < 10 ? ('0' + M) : M;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        let w = date.getDay();
        var show_day=new Array('周日','周一','周二','周三','周四','周五','周六'); 
        w = show_day[w]

        //console.log('d',y + '-' + m + '-' + d)

        switch (type) {
            case "array-y_m":
                return [y,m];
            case "hms":
                return y + '-' + m + '-' + d + " " + h + ':' + M + ':' + s;
            case "h:m:s":
                return h + ':' + M + ':' + s;
            case "y/m/d":
                return y + '/' + m + '/' + d;
            case "m/d":
                return m + '/' + d;
            case "ym":
                return y + '-'+ m;
            case "y_m":
                return y + ''+ m;
            case "ymd":
                return y + ''+ m + ''+ d;
            case "md":
                return m + ''+ d;
            case "w":
                return w;
            default:
                return y + '-' + m + '-' + d;
        }
    }
}

util.myBrowser = () => {
    var userAgent = navigator.userAgent;
    var _result;

    var _uas = [
        {target: 'Alipay', value: 'alipay'},
        {target: 'MicroMessenger', value: 'micromessenger'},
        {target: 'qq', value: 'qq'},
        {target: 'Opera', value: 'opera'},
        {target: 'Chrome', value: 'Chrome'},
        {target: 'Firefox', value: 'FF'},
        {target: 'Safari', value: 'Safari'},
        {target: 'compatible', value: 'IE'},
        {target: 'Trident', value: 'IE'},
        {target: 'Edge', value: 'Edge'}
    ];
    _uas.forEach(function (item) {
        var re = new RegExp(item.target, "i");
        if (re.test(userAgent) && !_result) {
            _result = item.value;
        }
    });
    return _result
}

util.objfilter = (obj)=> {
    var _result = {};
    var blacklist = [
        //{name: "startDate"},
    ]
    if (obj != undefined) {
        for (var i in obj) {
            //if ((_.isNumber(obj[i]) || obj[i] != "") && !_.isUndefined(obj[i]) && !_.isNull(obj[i])) {
            if(obj[i]!==''&&obj[i]!=undefined){
                _result[i] = obj[i];
                for (var j in blacklist) {
                    if ((obj[i] == "" || _result[i] == undefined) && i == blacklist[j].name) {
                        delete _result[i];
                    }
                }
            }

        }
    }
    return _result
}

// util.inOf = function (arr, targetArr) {
//     let res = true;
//     arr.forEach(item => {
//         if (targetArr.indexOf(item) < 0) {
//             res = false;
//         }
//     });
//     return res;
// };

// util.oneOf = function (ele, targetArr) {
//     if (targetArr.indexOf(ele) >= 0) {
//         return true;
//     } else {
//         return false;
//     }
// };

// util.showThisRoute = function (itAccess, currentAccess) {
//     if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
//         return util.oneOf(currentAccess, itAccess);
//     } else {
//         return itAccess === currentAccess;
//     }
// };

// util.getRouterObjByName = function (routers, name) {
//     if (!name || !routers || !routers.length) {
//         return null;
//     }
//     // debugger;
//     let routerObj = null;
//     for (let item of routers) {
//         if (item.name === name) {
//             return item;
//         }
//         routerObj = util.getRouterObjByName(item.children, name);
//         if (routerObj) {
//             return routerObj;
//         }
//     }
//     return null;
// };

// util.handleTitle = function (vm, item) {
//     if (typeof item.title === 'object') {
//         return vm.$t(item.title.i18n);
//     } else {
//         return item.title;
//     }
// };

// util.setCurrentPath = function (vm, name) {
//     let title = '';
//     let isOtherRouter = false;
//     vm.$store.state.app.routers.forEach(item => {
//         if (item.children.length === 1) {
//             if (item.children[0].name === name) {
//                 title = util.handleTitle(vm, item);
//                 if (item.name === 'otherRouter') {
//                     isOtherRouter = true;
//                 }
//             }
//         } else {
//             item.children.forEach(child => {
//                 if (child.name === name) {
//                     title = util.handleTitle(vm, child);
//                     if (item.name === 'otherRouter') {
//                         isOtherRouter = true;
//                     }
//                 }
//             });
//         }
//     });
//     let currentPathArr = [];
//     if (name === 'home_index') {
//         currentPathArr = [
//             {
//                 title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
//                 path: '',
//                 name: 'home_index'
//             }
//         ];
//     } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
//         currentPathArr = [
//             {
//                 title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
//                 path: '/home',
//                 name: 'home_index'
//             },
//             {
//                 title: title,
//                 path: '',
//                 name: name
//             }
//         ];
//     } else {
//         let currentPathObj = vm.$store.state.app.routers.filter(item => {
//             if (item.children.length <= 1) {
//                 return item.children[0].name === name;
//             } else {
//                 let i = 0;
//                 let childArr = item.children;
//                 let len = childArr.length;
//                 while (i < len) {
//                     if (childArr[i].name === name) {
//                         return true;
//                     }
//                     i++;
//                 }
//                 return false;
//             }
//         })[0];
//         if (currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
//             currentPathArr = [
//                 {
//                     title: '首页',
//                     path: '',
//                     name: 'home_index'
//                 }
//             ];
//         } else if (currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
//             currentPathArr = [
//                 {
//                     title: '首页',
//                     path: '/home',
//                     name: 'home_index'
//                 },
//                 {
//                     title: currentPathObj.title,
//                     path: '',
//                     name: name
//                 }
//             ];
//         } else {
//             let childObj = currentPathObj.children.filter((child) => {
//                 return child.name === name;
//             })[0];
//             currentPathArr = [
//                 {
//                     title: '首页',
//                     path: '/home',
//                     name: 'home_index'
//                 },
//                 {
//                     title: currentPathObj.title,
//                     path: '',
//                     name: currentPathObj.name
//                 },
//                 {
//                     title: childObj.title,
//                     path: currentPathObj.path + '/' + childObj.path,
//                     name: name
//                 }
//             ];
//         }
//     }
//     vm.$store.commit('setCurrentPath', currentPathArr);

//     return currentPathArr;
// };

// util.openNewPage = function (vm, name, argu, query) {
//     let pageOpenedList = vm.$store.state.app.pageOpenedList;
//     let openedPageLen = pageOpenedList.length;
//     let i = 0;
//     let tagHasOpened = false;
//     while (i < openedPageLen) {
//         if (name === pageOpenedList[i].name) { // 页面已经打开
//             vm.$store.commit('pageOpenedList', {
//                 index: i,
//                 argu: argu,
//                 query: query
//             });
//             tagHasOpened = true;
//             break;
//         }
//         i++;
//     }
//     if (!tagHasOpened) {
//         let tag = vm.$store.state.app.tagsList.filter((item) => {
//             if (item.children) {
//                 return name === item.children[0].name;
//             } else {
//                 return name === item.name;
//             }
//         });
//         tag = tag[0];
//         if (tag) {
//             tag = tag.children ? tag.children[0] : tag;
//             if (argu) {
//                 tag.argu = argu;
//             }
//             if (query) {
//                 tag.query = query;
//             }
//             vm.$store.commit('increateTag', tag);
//         }
//     }
//     vm.$store.commit('setCurrentPageName', name);
// };

// util.toDefaultPage = function (routers, name, route, next) {
//     let len = routers.length;
//     let i = 0;
//     let notHandle = true;
//     while (i < len) {
//         if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
//             route.replace({
//                 name: routers[i].children[0].name
//             });
//             notHandle = false;
//             next();
//             break;
//         }
//         i++;
//     }
//     if (notHandle) {
//         next();
//     }
// };

// util.fullscreenEvent = function (vm) {
//     vm.$store.commit('initCachepage');
//     // 权限菜单过滤相关
//     vm.$store.commit('updateMenulist');
//     // 全屏相关
// };

// util.checkUpdate = function (vm) {
//     axios.get('https://api.github.com/repos/iview/iview-admin/releases/latest').then(res => {
//         let version = res.data.tag_name;
//         vm.$Notice.config({
//             duration: 0
//         });
//         if (semver.lt(packjson.version, version)) {
//             vm.$Notice.info({
//                 title: 'iview-admin更新啦',
//                 desc: '<p>iView-admin更新到了' + version + '了，去看看有哪些变化吧</p><a style="font-size:13px;" href="https://github.com/iview/iview-admin/releases" target="_blank">前往github查看</a>'
//             });
//         }
//     });
// };

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js